import { ContactForm } from "components";
import React from "react";

const ContactSection = () => {
  return (
    <div className="w-full py-28 bg-white px-4" id="contact">
      <div className="max-w-[720px] mx-auto">
        <ContactForm />
      </div>
    </div>
  );
};

export default ContactSection;
